import React, { useMemo } from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table/';
import 'react-table/react-table.css';
import PT from 'prop-types';
import cn from 'classnames';

import BodyCell from './components/BodyCell';
import Pagination from './components/Pagination';
import EmptyComponent from 'Components/EmptyComponent';

const Table = (props) => {
  const {
    columns: columnsProps = [],
    data,
    className,
    reactTableProps,
    sortable,
    tableSettings: { hasHeader = true, hasBody = true, pageSize = 0, CustomRowComponent },
  } = props;

  const columns = useMemo(
    () =>
      columnsProps.map((el) => {
        const { title, cellProps } = el;
        return {
          Header: hasHeader ? title : EmptyComponent,
          Cell: hasBody ? (cellProps.Cell ? cellProps.Cell : BodyCell) : EmptyComponent,
          ...cellProps,
        };
      }),
    [columnsProps, hasHeader, hasBody]
  );

  return (
    <div
      className={cn(
        'table main-layout-table',
        {
          'table-empty':
            data && data.length && data[0].not_found && data[0].not_found.title === 'No contacts with this name',
          'table_with-pagination': data ? data.length > pageSize : null,
        },
        className
      )}
    >
      <ReactTable
        data={data}
        columns={columns}
        key={data}
        defaultPageSize={pageSize}
        PaginationComponent={Pagination}
        TheadComponent={hasHeader ? ReactTableDefaults.TheadComponent : EmptyComponent}
        TrGroupComponent={CustomRowComponent || ReactTableDefaults.TrGroupComponent}
        minRows={0}
        NoDataComponent={EmptyComponent}
        sortable={sortable}
        showPagination={!!data && data.length > pageSize}
        {...reactTableProps}
      />
    </div>
  );
};

Table.propTypes = {
  columns: PT.arrayOf(
    PT.shape({
      title: PT.oneOfType([PT.string, PT.number]),
      cellProps: PT.object,
    })
  ),
  data: PT.array,
  reactTableProps: PT.object,
  tableSettings: PT.object,
};

export default Table;
